import { render, staticRenderFns } from "./DataAuditScreen.vue?vue&type=template&id=52f2facc&scoped=true&"
import script from "./DataAuditScreen.vue?vue&type=script&lang=ts&"
export * from "./DataAuditScreen.vue?vue&type=script&lang=ts&"
import style0 from "./DataAuditScreen.vue?vue&type=style&index=0&id=52f2facc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2facc",
  null
  
)

export default component.exports